export class MoodQuestion {
  public id: number;
  public name: string;
  public projectId: number;
  public active: boolean;
  public deleted: boolean;
  public color: string;

  constructor(id: number, name: string, color: string, projectId: number = null,
    active = true, deleted = false) {
    this.id = id;
    this.name = name;
    this.projectId = projectId;
    this.active = active;
    this.deleted = deleted;
    this.color = color;
  }
}
